import * as React from "react";
import { LabelContext } from "./label-provider.mjs";
const useLabels = () => {
  return React.useContext(LabelContext);
};
export {
  useLabels
};
